import TxTable from "../../../components/tables/transactions-table/table"
import CenteredTableBody from "../../../components/ui/layouts/platform/body/CenteredTableBody"
import DataTableToolbar from "../../../components/ui/data-table/data-table-toolbar"
import { TableDataProvider } from "../../../context/TableDataContext"
import React from "react"
import { TableModals } from "../../../components/tables/transactions-table/TableModals"
import { ModalProvider } from "../../../context/ModalContext"

const TransactionsBody = () => {
	return (
		<TableDataProvider defaultView="orders">
			<ModalProvider>
				<CenteredTableBody className="max-h-[95%] overscroll-none overflow-hidden scrollbar-hide">
					<MemoizedDataTableToolbar />
					<MemoizedTxTable scrollable viewOptions />
					<MemoizedTableModals />
					<div className="pointer-events-none fixed inset-x-0 bottom-0 lg:bottom-[4%] h-[7%] bg-gradient-to-t from-white dark:from-background" />
				</CenteredTableBody>
			</ModalProvider>
		</TableDataProvider>
	)
}

const MemoizedDataTableToolbar = React.memo(DataTableToolbar)
const MemoizedTxTable = React.memo(TxTable)
const MemoizedTableModals = React.memo(TableModals)

export default TransactionsBody
